"use client";
import { jsxs as t, jsx as e } from "react/jsx-runtime";
const d = ({
  title: i,
  titleId: n,
  desc: r,
  descId: o,
  ...s
}) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": n,
    "aria-describedby": o,
    ...s,
    children: [
      r ? /* @__PURE__ */ e("desc", { id: o, children: r }) : null,
      i ? /* @__PURE__ */ e("title", { id: n, children: i }) : null,
      /* @__PURE__ */ e(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "M6.06 20.9125c1.21.55 2.75.55 3.9601 0 1.21-.55 2.75-.55 3.96 0s2.75.55 3.96 0M12 3v2m-8 8H2m4.3141-5.6859L4.9 5.9m12.7856 1.4142L19.0998 5.9M22 13h-2M7 13c0-2.7614 2.2386-5 5-5s5 2.2386 5 5M2.1001 17.4125c1.21-.55 2.75-.55 3.96 0s2.75.55 3.96 0 2.75-.55 3.96 0 2.75.55 3.96 0 2.75-.55 3.96 0"
        }
      )
    ]
  }
);
export {
  d as default
};
//# sourceMappingURL=EveningIcon.js.map
